import * as storage from "./LocalStorage"

export const CALLBACK_EMAIL_VERIFICATION_KEY = "callback_email_verification";
export const CALLBACK_RESET_PASSWORD_KEY = "callback_reset_password";
export const TENANT_EXPIRATION_DAYS = 5;

const getCallbackEmailVerification = () => {
    if (storage.checkIfExists(CALLBACK_EMAIL_VERIFICATION_KEY)) {
        const itemCallbackEmailVerification = storage.checkExpiration(CALLBACK_EMAIL_VERIFICATION_KEY, TENANT_EXPIRATION_DAYS)
        return itemCallbackEmailVerification && itemCallbackEmailVerification.value;
    }
    return null;
}
const setCallbackEmailVerification = (value) => {//
    storage.setExpiredItemByDays(CALLBACK_EMAIL_VERIFICATION_KEY, value, TENANT_EXPIRATION_DAYS)
}
const deleteCallbackEmailVerification = () => {
    storage.removeItem(CALLBACK_EMAIL_VERIFICATION_KEY);
}

const getCallbackResetPassword = () => {
    if (storage.checkIfExists(CALLBACK_RESET_PASSWORD_KEY)) {
        const itemCallbackResetPassword = storage.checkExpiration(CALLBACK_RESET_PASSWORD_KEY, TENANT_EXPIRATION_DAYS);
        return itemCallbackResetPassword && itemCallbackResetPassword.value
    }
    return null;
}
const setCallbackResetPassword = (value) => {
    storage.setExpiredItemByDays(CALLBACK_RESET_PASSWORD_KEY, value, TENANT_EXPIRATION_DAYS)
}
const deleteCallbackResetPassword = () => {
    storage.removeItem(CALLBACK_RESET_PASSWORD_KEY);
}

export {
    getCallbackEmailVerification,
    setCallbackEmailVerification,
    deleteCallbackEmailVerification,
    getCallbackResetPassword,
    setCallbackResetPassword,
    deleteCallbackResetPassword
};